import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-access-layout',
  templateUrl: './access-layout.component.html',
})
export class AccessLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
    console.log('Access Layout init');
  }
}
